var _circle, _path, _path2, _ellipse, _ellipse2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 58.5,
    stroke: "#00955F",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6665 50.0003C18.6665 50.0003 21.9687 43.2729 25.3332 40.0003C29.593 35.8569 32.8861 34.0457 38.6665 32.667",
    stroke: "#00955F",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2789 32.0637C81.2789 32.0637 88.4218 34.3313 92.1573 37.173C96.8869 40.771 99.1665 43.7589 101.388 49.2709",
    stroke: "#00955F",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.6668,
    cy: 57.3337,
    rx: 7.33333,
    ry: 10.6667,
    fill: "#00955F"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.3333,
    cy: 57.3337,
    rx: 7.33333,
    ry: 10.6667,
    fill: "#00955F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46 100.667C46 97.3333 50 90 59.3333 90C68.6667 90 74.6667 97.9992 74.6667 100.667",
    stroke: "#00955F",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.04a8bd6655129c8c4c740818ade8332d.svg";
export { ForwardRef as ReactComponent };